import React, {useState} from 'react';
import {Button, Form, Modal} from "antd";
import dayjs from "dayjs";
import PropTypes from 'prop-types';

import CreditCardForm from "./CreditCardForm";
import {storeCreditCard} from "../../helpers/creditCard";
import {messageType, showMessages} from "../../helpers/message";
import {useGetCompanyInfoQuery} from "../../store/api/settingsApi";

const StoreCreditCardForm = ({visible, onCancel, onSubmit, formText}) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const {data: companyInfo} = useGetCompanyInfoQuery();

    const onFinish = async (values) => {
        const number = values['Card Number'].toString();
        const cvc = values['CVC'].toString();

        const expiryYear = values['Year'];
        const expiryMonth = values['Month'];
        const expiryDateString = `${expiryYear}-${expiryMonth}`;

        if (sanityCheck(expiryDateString) === false) {
            return;
        }

        try {
            setLoading(true);
            await storeCreditCard(number, expiryDateString, cvc);
            showMessages('Credit card has successfully been stored.', messageType.success);

            form.resetFields();
            setLoading(false);
            onSubmit();
        } catch (error) {
            setLoading(false);
            showMessages(error.message, messageType.error);
        }
    }

    const sanityCheck = (expiryDateString) => {
        const dateFormat = 'YYYY-M-D';
        const expiryDate = dayjs(expiryDateString, dateFormat).tz();
        const firstDayOfCurrentMonth = dayjs().tz().startOf('month').utc();

        if (expiryDate.utc().isBefore(firstDayOfCurrentMonth.utc())) {
            showMessages('The card has expired.', messageType.error);
            return false;
        }
        return true;
    }

    const getAuthorizationInfoMessage = () => {
        let companyName = 'us';
        if (companyInfo && companyInfo.name) {
            companyName = companyInfo.name;
        }
        return `By storing this credit card on file, you are authorizing ${companyName} to use it for automatic payments for all charges on your account.`;
    };

    return (
        <Modal
            title={formText}
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button
                    form="store-credit-card"
                    htmlType="submit"
                    type="primary"
                    key="submit"
                    loading={loading}
                >
                    {formText}
                </Button>
            ]}
        >
            <Form
                id="store-credit-card"
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <CreditCardForm/>
            </Form>

            {getAuthorizationInfoMessage()}
        </Modal>
    )
};

export default StoreCreditCardForm;

StoreCreditCardForm.propTypes = {
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    formText: PropTypes.string.isRequired,
}

StoreCreditCardForm.defaultProps = {
    formText: 'Add Credit Card',
}
